var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.cellValue,"id":_vm.ctrlId,"prefix":"$","single-line":"","readonly":"","height":"24"}})}
var staticRenderFns = []

export { render, staticRenderFns }